module.exports = __webpack_public_path__ + "img/gy.0653b318.svg";